import React, { Component } from 'react'
import './ContactForm.css'
import axios from 'axios';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import { connect } from 'react-redux';
import { handleAlertOpen } from '../redux/actions/alertActions';

const TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

class ContactForm extends Component {
	constructor(props) {
		super(props);

		this.handleAlertOpen = this.props.handleAlertOpen.bind(this);
		this.widgetId = null;

		this.state = {
			inputEmail: '',
			inputMessage: '',
			inputName: '',
			emailInputDirty: false,
			messageInputDirty: false,
			nameInputDirty: false,
			captchaToken: '',
			sending: false
		};
	}

	componentDidMount() {
		this.loadTurnstile();
	}

	// Load the Cloudflare Turnstile script once, then render the widget.
	loadTurnstile() {
		if (window.turnstile) {
			this.renderTurnstile();
			return;
		}
		const existing = document.querySelector('script[data-turnstile]');
		if (existing) {
			existing.addEventListener('load', () => this.renderTurnstile());
			return;
		}
		const script = document.createElement('script');
		script.src = TURNSTILE_SRC;
		script.async = true;
		script.defer = true;
		script.setAttribute('data-turnstile', 'true');
		script.onload = () => this.renderTurnstile();
		document.head.appendChild(script);
	}

	renderTurnstile() {
		if (!window.turnstile || !this.captchaRef || this.widgetId != null) {
			return;
		}
		this.widgetId = window.turnstile.render(this.captchaRef, {
			sitekey: this.props.turnstileSiteKey,
			callback: (token) => this.setState({ captchaToken: token }),
			'error-callback': () => this.setState({ captchaToken: '' }),
			'expired-callback': () => this.setState({ captchaToken: '' }),
			theme: 'auto'
		});
	}

	resetTurnstile() {
		if (window.turnstile && this.widgetId != null) {
			window.turnstile.reset(this.widgetId);
		}
		this.setState({ captchaToken: '' });
	}

	handleBlur(event) {
		this.handleInput(event);
	}

	handleInput(event) {
		this.setState({ [event.target.id + 'InputDirty']: true });
		if (event.target.id === 'name') this.nameValidation(event);
		else if (event.target.id === 'email') this.emailValidation(event);
		else if (event.target.id === 'message') this.messageValidation(event);
	}

	nameValidation(event) {
		if (event.target.value.length === 0) {
			this.setState({ inputName: '', inputNameError: true });
		} else {
			this.setState({ inputName: event.target.value, inputNameError: false });
		}
	}

	messageValidation(event) {
		if (event.target.value.length === 0) {
			this.setState({ inputMessage: '', inputMessageError: true });
		} else {
			this.setState({ inputMessage: event.target.value, inputMessageError: false });
		}
	}

	emailValidation(event) {
		// eslint-disable-next-line
		const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (event.target.value.length === 0) {
			this.setState({ inputEmail: '', inputEmailErrorText: null, inputEmailError: true });
		} else if (reg.test(String(event.target.value).toLowerCase())) {
			this.setState({ inputEmail: event.target.value, inputEmailErrorText: null, inputEmailError: false });
		} else {
			this.setState({ inputEmailErrorText: 'Invalid email address', inputEmailError: true });
		}
	}

	isValid() {
		return (
			this.state.inputName.length > 0 &&
			this.state.inputEmail.length > 0 &&
			this.state.inputMessage.length > 0 &&
			this.state.captchaToken.length > 0 &&
			!this.state.sending
		);
	}

	handleFormSubmit = () => {
		if (!this.isValid()) return;
		this.setState({ sending: true });

		axios
			.post('/rest/connect/email', {
				name: this.state.inputName,
				email: this.state.inputEmail,
				message: this.state.inputMessage,
				token: this.state.captchaToken
			})
			.then(() => {
				this.setState({
					inputEmail: '',
					inputMessage: '',
					inputName: '',
					emailInputDirty: false,
					messageInputDirty: false,
					nameInputDirty: false,
					captchaToken: '',
					sending: false
				});
				this.resetTurnstile();
				this.handleAlertOpen({
					title: 'Message sent',
					severity: 'success',
					message: 'Thanks — your message is on its way. Newfangle Press will get back to you soon.'
				});
			})
			.catch(() => {
				this.setState({ sending: false });
				this.resetTurnstile();
				this.handleAlertOpen({
					title: 'Something went wrong',
					severity: 'error',
					message: 'Your message could not be sent. Please try again in a moment.'
				});
			});
	};

	render() {
		return (
			<div>
				<div>
					<TextField required id="name" label="Your Name" style={{ width: '80%' }} onChange={this.handleInput.bind(this)} onBlur={this.handleBlur.bind(this)} helperText={this.state.inputNameErrorText} error={this.state.inputNameError} />
				</div>
				<div>
					<TextField required id="email" label="Your Email" style={{ width: '80%' }} type="email" onChange={this.handleInput.bind(this)} onBlur={this.handleBlur.bind(this)} helperText={this.state.inputEmailErrorText} error={this.state.inputEmailError} />
				</div>
				<div>
					<TextareaAutosize required id="message" aria-label="Message" rowsMin={3} placeholder="Message" style={{ width: '80%', marginTop: '15px' }} onChange={this.handleInput.bind(this)} onBlur={this.handleBlur.bind(this)} />
				</div>
				<div style={{ marginTop: '16px' }} ref={(el) => { this.captchaRef = el; }} />
				<div style={{ marginTop: '16px' }}>
					<button type="button" className="nf-btn" onClick={this.handleFormSubmit} disabled={!this.isValid()}>
						{this.state.sending ? 'Sending…' : 'Send'}
					</button>
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		handleAlertOpen: (alert) => {
			dispatch(handleAlertOpen(alert));
		}
	};
};

const mapStateToProps = (state) => {
	return {
		turnstileSiteKey: state.site.turnstileSiteKey
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);
